var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dropdown", attrs: { id: "dropdown-filters-wrapper" } },
    [
      _c(
        "a",
        {
          staticClass: "dropdown-toggle clickable",
          attrs: { id: "dropdown-filters", "data-toggle": "dropdown" },
        },
        [
          _c(
            "b",
            { staticClass: "bold text-black" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$tc("global.words.filter", 2)) +
                  "\n      "
              ),
              _vm.hasActiveFilters
                ? _c(
                    "badge",
                    { staticClass: "ml-1", attrs: { type: "primary" } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("global.words.active")) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dropdown-menu",
          attrs: { id: "dropdown-filters-content" },
        },
        [
          _c(
            "form",
            {
              attrs: { id: "profile-filters-form" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  $event.stopPropagation()
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "row no-gutters justify-content-between" },
                [
                  _c("div", { staticClass: "col py-2 filter-title" }, [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.$t("global.actions.filterBy")) + " ..."
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col py-2" }),
                  _vm._v(" "),
                  _vm.hasActiveFilters
                    ? _c(
                        "a",
                        {
                          staticClass: "clickable",
                          on: { click: _vm.clearAllFilters },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("global.actions.clearAll")) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c("div", { staticClass: "col-sm-6 col-12" }, [
                    _c("div", { staticClass: "row no-gutters" }, [
                      _c("div", { staticClass: "col-12 py-2" }, [
                        _c("b", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("boards.messages.upcomingMilestones")
                            ) + ":"
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 d-flex flex-column" }, [
                        _c(
                          "div",
                          { staticClass: "pretty p-icon p-smooth mr-0 mb-3" },
                          [
                            _c("input", {
                              staticClass: "form-check-input",
                              attrs: {
                                id: "board-filter--past-important-dates",
                                type: "checkbox",
                              },
                              domProps: {
                                checked: _vm.upcomingMilestones["past-due"],
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleUpcomingChange(
                                    $event,
                                    "past-due"
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "state p-primary" }, [
                              _c("i", { staticClass: "icon fa fa-check" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "clickable text-danger",
                                  attrs: {
                                    for: "board-filter--past-important-dates",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("boards.filters.pastDue")) +
                                      "\n                  "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pretty p-icon p-smooth mr-0 mb-3" },
                          [
                            _c("input", {
                              staticClass: "form-check-input",
                              attrs: {
                                id: "board-filter--active-important-dates",
                                type: "checkbox",
                              },
                              domProps: {
                                checked: _vm.upcomingMilestones.active,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleUpcomingChange(
                                    $event,
                                    "active"
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "state p-primary" }, [
                              _c("i", { staticClass: "icon fa fa-check" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "clickable text-success",
                                  attrs: {
                                    for: "board-filter--active-important-dates",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t("boards.filters.dueToday")
                                      ) +
                                      "\n                  "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pretty p-icon p-smooth mr-0 mb-3" },
                          [
                            _c("input", {
                              staticClass: "form-check-input",
                              attrs: {
                                id: "board-filter--upcoming-important-dates",
                                type: "checkbox",
                              },
                              domProps: {
                                checked: _vm.upcomingMilestones.upcoming,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleUpcomingChange(
                                    $event,
                                    "upcoming"
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "state p-primary" }, [
                              _c("i", { staticClass: "icon fa fa-check" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "clickable text-warning-darker",
                                  attrs: {
                                    for: "board-filter--upcoming-important-dates",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t("boards.filters.upcomingWeeks")
                                      ) +
                                      "\n                  "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pretty p-icon p-smooth mr-0 mb-3" },
                          [
                            _c("input", {
                              staticClass: "form-check-input",
                              attrs: {
                                id: "board-filter--planned-important-dates",
                                type: "checkbox",
                              },
                              domProps: {
                                checked: _vm.upcomingMilestones.planned,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleUpcomingChange(
                                    $event,
                                    "planned"
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "state p-primary" }, [
                              _c("i", { staticClass: "icon fa fa-check" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "clickable text-black",
                                  attrs: {
                                    for: "board-filter--planned-important-dates",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t("boards.filters.plannedWeeks")
                                      ) +
                                      "\n                  "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-6 col-12" }, [
                    _c("div", { staticClass: "row no-gutters" }, [
                      _c("div", { staticClass: "col py-2" }, [
                        _c("b", [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm.$tc("global.words.activity", 2)
                              )
                            ) + ":"
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 d-flex flex-column" }, [
                        _c(
                          "div",
                          { staticClass: "pretty p-icon p-smooth mr-0 mb-3" },
                          [
                            _c("input", {
                              staticClass: "form-check-input",
                              attrs: {
                                id: "board-filter--past-activities",
                                type: "checkbox",
                              },
                              domProps: { checked: _vm.activities["past-due"] },
                              on: {
                                change: function ($event) {
                                  return _vm.handleActivitiesChange(
                                    $event,
                                    "past-due"
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "state p-primary" }, [
                              _c("i", { staticClass: "icon fa fa-check" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "clickable text-danger",
                                  attrs: {
                                    for: "board-filter--past-activities",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("boards.filters.pastDue")) +
                                      "\n                  "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pretty p-icon p-smooth mr-0 mb-3" },
                          [
                            _c("input", {
                              staticClass: "form-check-input",
                              attrs: {
                                id: "board-filter--active-activities",
                                type: "checkbox",
                              },
                              domProps: { checked: _vm.activities.active },
                              on: {
                                change: function ($event) {
                                  return _vm.handleActivitiesChange(
                                    $event,
                                    "active"
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "state p-primary" }, [
                              _c("i", { staticClass: "icon fa fa-check" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "clickable text-success",
                                  attrs: {
                                    for: "board-filter--active-activities",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t("boards.filters.dueToday")
                                      ) +
                                      "\n                  "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pretty p-icon p-smooth mr-0 mb-3" },
                          [
                            _c("input", {
                              staticClass: "form-check-input",
                              attrs: {
                                id: "board-filter--upcoming-activities",
                                type: "checkbox",
                              },
                              domProps: { checked: _vm.activities.upcoming },
                              on: {
                                change: function ($event) {
                                  return _vm.handleActivitiesChange(
                                    $event,
                                    "upcoming"
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "state p-primary" }, [
                              _c("i", { staticClass: "icon fa fa-check" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "clickable text-warning-darker",
                                  attrs: {
                                    for: "board-filter--upcoming-activities",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t("boards.filters.upcomingWeeks")
                                      ) +
                                      "\n                  "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pretty p-icon p-smooth mr-0 mb-3" },
                          [
                            _c("input", {
                              staticClass: "form-check-input",
                              attrs: {
                                id: "board-filter--planned-activities",
                                type: "checkbox",
                              },
                              domProps: { checked: _vm.activities.planned },
                              on: {
                                change: function ($event) {
                                  return _vm.handleActivitiesChange(
                                    $event,
                                    "planned"
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "state p-primary" }, [
                              _c("i", { staticClass: "icon fa fa-check" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "clickable text-black",
                                  attrs: {
                                    for: "board-filter--planned-activities",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t("boards.filters.plannedWeeks")
                                      ) +
                                      "\n                  "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm-6 col-12" },
                    [
                      _c("select-filter", {
                        attrs: {
                          name: "referrer-filter",
                          capitalize: "",
                          label:
                            _vm.$tc(
                              "global.doorr.referrerSlashParticipant",
                              2
                            ) + ":",
                          "results-template-name": "referrers-dropdown",
                          placeholder:
                            "" +
                            _vm.$t("boards.messages.selectToFilter", {
                              item: _vm.$tc(
                                "global.doorr.referrerSlashParticipant",
                                2
                              ),
                            }),
                          data: _vm.referrersWithNone,
                          value: _vm.selectedReferrers,
                        },
                        on: { change: _vm.handleSelect2Change },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm-6 col-12" },
                    [
                      _c("select-filter", {
                        attrs: {
                          name: "agent-filter",
                          capitalize: "",
                          label: _vm.$tc("global.doorr.agent", 2) + ":",
                          "results-template-name": "assignee-dropdown",
                          placeholder:
                            "" +
                            _vm.$t("boards.messages.selectToFilter", {
                              item: _vm.$tc("global.doorr.agent", 2),
                            }),
                          data: _vm.agentsWithNone,
                          value: _vm.selectedAgents,
                        },
                        on: { change: _vm.handleSelect2Change },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("select-filter", {
                        attrs: {
                          name: "collab-filter",
                          capitalize: "",
                          label: _vm.$tc("global.doorr.collaborators", 2) + ":",
                          "results-template-name": "assignee-dropdown",
                          placeholder:
                            "" +
                            _vm.$t("boards.messages.selectToFilter", {
                              item: _vm.$tc("global.doorr.collaborators", 2),
                            }),
                          data: _vm.collaboratorsWithNone,
                          value: _vm.selectedCollaborators,
                        },
                        on: { change: _vm.handleSelect2Change },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-col", { staticClass: "pt-2", attrs: { cols: "12" } }, [
                    _c("b", [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(_vm.$tc("global.words.color", 2))
                        ) + ":"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "pb-2", attrs: { cols: "12" } },
                    [
                      _c("color-selector", {
                        ref: "colorSelector",
                        attrs: {
                          colors: _vm.cardColors,
                          "pre-selected-colors": _vm.value.colors,
                        },
                        on: { select: _vm.handleSelectColor },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }